export default "__VITE_PUBLIC_ASSET__45c5c293__"